import React from 'react';
import PropTypes from 'prop-types';


import DialogContent from '@mui/material/DialogContent';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';


import DepotGestionAutocomplete from 'components/Shared/DepotGestionAutocomplete';

import DropZone from 'components/Shared/DropZone';
import { ReclamationActionDetailCodes, ReclamationActionDetailType } from 'constants.js';

import stringHelper from 'utils/stringHelper';

import { MotifResolutionCodes } from 'constants.js';
import { CausePrincipaleCodes } from 'constants.js';


/* Liste des réponses possibles */
const actionsEffectuees = [
    'Échange produit en magasin',
    'Avoir client en magasin',
    'Relivraison (enlèvement agence)',
    'Relivraison (livraison client)',
    'Pas d\'action'
    /* Attention à bien vérifier le AddActionCommandHandler  #region MagasinProblemeTransport en cas de modification */
];



/* Liste des réponses possibles */
const demandesClient = [
    'Le client demande à être remboursé',
    'Le client demande à être relivré',
    'Pas d\'action'
];



class ProblemeTransportDialogContent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            modeLivraison: props.modeLivraison,
            nbColis: 0,
            reserveTransporteur: null,
            defaut: '',
            actionEffectuee: '',
            codeDepot: props.codeDepot,
            demandeClient: '',
            fichiersIds: []
        };
    }

    componentDidMount() {
        const actionData = this.getActionData(this.state);

        this.props.onChange(actionData);
    }

    getActionData(newState) {
        const { action } = this.props;

        if (newState.actionEffectuee === '') {
            return null;
        }
        if (newState.demandeClient === '') {
            return null;
        }

        if (stringHelper.isNullOrWhitespace(newState.defaut)) {
            return null;
        }

        if (!newState.codeDepot) {
            return null;
        }

        if (newState.reserveTransporteur === null) {
            return null;
        }
                
        const actionData = {
            code: action.code,
            details: [{
                code: ReclamationActionDetailCodes.Depot,
                type: ReclamationActionDetailType.CodeDepot,
                libelle: 'Dépôt concerné',
                position: 0,
                valeurString: newState.codeDepot
            }, {
                code: ReclamationActionDetailCodes.Reponse,
                type: ReclamationActionDetailType.Texte,
                libelle: 'Mode de livraison',
                position: 1,
                valeurString: newState.modeLivraison === '0' ? 'Livraison enlèvement agence' : 'Livraison chez le client'
            }, {
                code: ReclamationActionDetailCodes.NombreColis,
                type: ReclamationActionDetailType.Entier,
                libelle: 'Combien de colis avez-vous reçus ?',
                position: 2,
                valeurInteger: newState.nbColis
            }, {
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.Booleen,
                libelle: 'Avez-vous fait une réserve auprès du transporteur ?',
                position: 3,
                valeurBool: newState.reserveTransporteur === '0' ? true : false
            }, {
                code: ReclamationActionDetailCodes.Memo,
                type: ReclamationActionDetailType.Texte,
                libelle: 'Défaut constaté',
                position: 4,
                valeurString: newState.defaut
            }, {
                code: ReclamationActionDetailCodes.ActionEffectuee,
                type: ReclamationActionDetailType.ChoixSimple,
                libelle: 'Action déjà effectuée vis à vis du client',
                position: 5,
                valeurString: actionsEffectuees[newState.actionEffectuee],
                valeurInteger: newState.actionEffectuee
            }, {
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.ChoixSimple,
                libelle: 'Demande du client',
                position: 6,
                valeurString: demandesClient[newState.demandeClient],
                valeurInteger: newState.demandeClient
            }
            ]
        };

        if (newState.fichiersIds.length > 0) {
            actionData.fichiersIds = newState.fichiersIds;
        }

        return actionData;
    }

    handleChange = (event) => {
        const newState = {
            ...this.state,
            [event.target.name]: event.target.value
        };

        this.setState(newState);

        const actionData = this.getActionData(newState);

        let clotureData = null;

        if (actionData) {
            
            clotureData = {
                motifResolutionCode: MotifResolutionCodes.JustifieeClasseeSansSuite,
                causePrincipaleCode: CausePrincipaleCodes.ProblemeTransporteur,
                causePrincipaleDetailId: 0,
                utilisateurFautifId: 0,
                commentaire: '',
                mailAutomatique: ''
            };  

            switch (newState.actionEffectuee) {
                case 0: // 'Échange produit en magasin'
                    clotureData.motifResolutionCode = MotifResolutionCodes.RenvoiMarchandiseAvoirRenvoi;
                    break;
                case 1: // 'Avoir client en magasin'
                    clotureData.motifResolutionCode = MotifResolutionCodes.AvoirClientAvecRetour;
                    break;
                case 2: // 'Relivraison (enlèvement agence)'
                case 3: // 'Relivraison (livraison client)'
                    clotureData.motifResolutionCode = MotifResolutionCodes.RenvoiMarchandiseFacture;
                    break;
                case 4: // 'Pas d\'action'
                default:
                    break;
            }
  
        }


        this.props.onChange(actionData, clotureData);
    }

    render() {
        const { modeLivraison, nbColis, reserveTransporteur, defaut, actionEffectuee, demandeClient, codeDepot } = this.state;
        

        return (
            <DialogContent>

                <Stack spacing={1}>

                    <>
                        <Typography variant="body1" gutterBottom>Effectuer cette action pour :</Typography>
                        <Typography variant="body2" gutterBottom>{`Générer un dossier après-vente lié affecté au groupe Service transport`}</Typography>
                    </>

                    <DepotGestionAutocomplete
                        value={codeDepot}
                        onChange={(e, codeDepot, depot) => { this.handleChange({ target: { name: 'codeDepot', value: codeDepot } }); }}
                        label={"Dépôt"}
                        magasinsSeulement={false}
                        plateformesSeulement={false}
                        autoFocus
                        modeTri={0}
                        required={true}
                        disabled={false}
                    />


                    <TextField
                        id={'modeLivraison'}
                        name={'modeLivraison'}
                        label={"Mode de livraison"}
                        fullWidth
                        sx={{ mt: 1 }}

                        select
                        SelectProps={{
                            value: modeLivraison,
                            onChange: this.handleChange
                        }}
                    >
                        <MenuItem value="0">Livraison enlèvement agence</MenuItem>
                        <MenuItem value="1">Livraison chez le client</MenuItem>
                    </TextField>


                    <TextField
                        required
                        id="nbColis"
                        name="nbColis"
                        label="Combien de colis avez-vous reçus ?"
                        value={nbColis}
                        onChange={this.handleChange}
                        fullWidth


                        type="number"
                        inputProps={{ min: 0 }}
                    />

                    <FormControl required>
                        <FormLabel>Avez-vous fait une réserve auprès du transporteur ?</FormLabel>
                        <RadioGroup id="reserveTransporteur" name="reserveTransporteur" value={reserveTransporteur} onChange={this.handleChange}>
                            <FormControlLabel value="0" control={<Radio />} label="Oui" />
                            <FormControlLabel value="1" control={<Radio />} label="Non" />
                        </RadioGroup>
                    </FormControl>

                    <TextField required id="defaut" name="defaut" label="Défaut constaté" value={defaut} onChange={this.handleChange} multiline fullWidth />
                                


                    <TextField
                        id={'actionEffectuee'}
                        name={'actionEffectuee'}
                        label={"Action déjà effectuée vis à vis du client"}
                        fullWidth
                        required
                        sx={{ mt: 1 }}

                        select
                        SelectProps={{
                            value: actionEffectuee,
                            onChange: this.handleChange
                        }}
                    >
                        {actionsEffectuees.map((reponse, index) => (
                            <MenuItem key={index} value={index}>
                                {reponse}
                            </MenuItem>
                        ))}
                    </TextField>



                    <TextField
                        id={'demandeClient'}
                        name={'demandeClient'}
                        label={"Demande du client"}
                        fullWidth
                        required
                        sx={{ mt: 1 }}

                        select
                        SelectProps={{
                            value: demandeClient,
                            onChange: this.handleChange
                        }}
                    >
                        {demandesClient.map((reponse, index) => (
                            <MenuItem key={index} value={index}>
                                {reponse}
                            </MenuItem>
                        ))}
                    </TextField>
                
                    <DropZone id="fichiersIds" name="fichiersIds" onChange={this.handleChange} />
                </Stack>
            </DialogContent>
        );
    }
}

ProblemeTransportDialogContent.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired,
    codeDepot: PropTypes.string
};


export default ProblemeTransportDialogContent;